import { getCurrentUser } from 'web-fns/dist/auth'

export const isModerator = (): boolean => {
  const currentUser = getCurrentUser()
  return !!(
    currentUser &&
    currentUser.user_roles &&
    currentUser.user_roles.includes('General Manager')
  )
}



// WEBPACK FOOTER //
// ./src/helpers/role-helper.ts